import { createContext, useContext } from 'react';
import type { CmsPageContent } from './types';

/**
 * Context to share CMS page data across multiple components.
 */
export const CmsPageContext = createContext<CmsPageContent>({} as CmsPageContent);

export const useCmsPageContext = (): CmsPageContent | undefined => useContext(CmsPageContext);
